import api from './client';
import type { AxiosResponse } from 'axios';

// Public — no auth required
export const getPublicPlans = (): Promise<AxiosResponse> => api.get('/payments/plans');
export const getFoundingStatusPublic = (): Promise<AxiosResponse> => api.get('/founding-status');

export const createPublicCheckout = (
  plan: string,
  email: string,
  ref?: string,
): Promise<AxiosResponse> =>
  api.post('/payments/public-checkout', {
    plan,
    email,
    origin_url: window.location.origin,
    ...(ref ? { ref } : {}),
  });

export const getPublicCheckoutStatus = (sessionId: string): Promise<AxiosResponse> =>
  api.get(`/payments/public-status/${sessionId}`);

// Founding-referral link — public lookup so /pricing?ref=ABC123 can show
// "Sarah invited you" before the visitor enters their email.
export type ReferralLookup = {
  code: string;
  referrer_first_name: string;
  referrer_is_founding: boolean;
  reward_days: number;
};
export const lookupReferralCode = (code: string): Promise<AxiosResponse<ReferralLookup>> =>
  api.get(`/referral/public-lookup?code=${encodeURIComponent(code)}`);

// Logged-in member dashboard data (link + paid referees + bonus days)
export type ReferralStats = {
  code: string;
  share_url_path: string;
  paid_referrals: number;
  bonus_days_earned: number;
  reward_days_per_referral: number;
  premium_expires: string | null;
};
export const getReferralStats = (): Promise<AxiosResponse<ReferralStats>> =>
  api.get('/referral/me/stats');
